import React, { useEffect } from "react";
import '../../Styles/skills.css'
import AOS from "aos";
import "aos/dist/aos.css";
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';


const Skills = () => {

  return (
    <div className="page-container">
      <div className="page-title">
        <h1 data-aos="fade-up">SKILLS</h1>
      </div>
      <div className="page-div">
        <Grid container spacing={2} justifyContent="start">
          <Grid item xs={12} sm={6} md={4} data-aos="flip-left">
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h4" component="div" fontWeight='bold'>
                React
              </Typography>
              <Typography color="text.secondary" variant="body1">
                <Typography variant="body1" display="inline" color="text.primary" fontWeight='bold'>
                  Hook{'  '}
                </Typography>
                <Typography variant="body1" display="inline">
                  효과적인 상태 관리를 위한 Hook 사용 가능
                </Typography><br />
                <Typography variant="body1" display="inline" color="text.primary" fontWeight='bold'>
                  Router{'  '}
                </Typography>
                <Typography variant="body1" display="inline">
                  라우팅 및 내비게이션
                </Typography><br />
                <Typography variant="body1" display="inline" color="text.primary" fontWeight='bold'>
                  react-cookie{'  '}
                </Typography>
                <Typography variant="body1" display="inline">
                  JWT 토큰을 위한 쿠키 관리
                </Typography><br />
                <Typography variant="body1" display="inline" color="text.primary" fontWeight='bold'>
                  react-chartjs-2{'  '}
                </Typography>
                <Typography variant="body1" display="inline">
                  데이터 시각화
                </Typography><br />
                <Typography variant="body1" display="inline" color="text.primary" fontWeight='bold'>
                  axios{'  '}
                </Typography>
                <Typography variant="body1" display="inline">
                  서버와의 HTTP 통신
                </Typography><br />
                <Typography variant="body1" display="inline" color="text.primary" fontWeight='bold'>
                  react-responsive{'  '}
                </Typography>
                <Typography variant="body1" display="inline">
                  반응형 구현
                </Typography><br />
                <Typography variant="body1" display="inline" color="text.primary" fontWeight='bold'>
                  기타 지도 관련 API{'  '}
                </Typography>
                <br />
              </Typography>
            </CardContent>
          </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} data-aos="flip-left">
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h4" component="div" fontWeight='bold'>
                Spring Boot
              </Typography>
              <Typography color="text.secondary" variant="body1">
                <Typography variant="body1">
                  RESTful API 개발
                </Typography>
                <Typography variant="body1">
                  Thymeleaf, JSP 등의 뷰 템플릿 사용
                </Typography>
                <Typography variant="body1">
                  DB연결
                </Typography>
                <Typography variant="body1">
                  JWT 활용한 인증, 권한 관리
                </Typography>
              </Typography>
            </CardContent>
          </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={4} data-aos="flip-left">
          <Card variant="outlined">
            <CardContent>
              <Typography variant="h4" component="div" fontWeight='bold'>
                MySQL
              </Typography>
              <Typography color="text.secondary" variant="body1">
                <Typography variant="body1">
                  쿼리문 작성
                </Typography>
                <Typography variant="body1">
                  데이터 CRUD
                </Typography>
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
    </div >
  )
}

export default Skills